"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
/**
 * Renders the Pdf icon
 * @param {React.SVGProps<SVGSVGElement>} props - The props for the Pdf component
 * @returns {JSX.Element} - The Pdf component
 * @example
 * <Pdf />
 * @example
 * <Pdf height={24} width={24} />
 * @example
 * <Pdf className="custom-class" />
 */
function Pdf({ isDecorative, ...props }) {
    return (react_1.default.createElement("svg", { fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg", ...props },
        react_1.default.createElement("path", { d: "m15.9393 3.23223-.3515.35154.3515-.35154c-.4688-.46884-1.1047-.73223-1.7677-.73223h-8.1716c-.82843 0-1.5.67157-1.5 1.5v16c0 .8284.67157 1.5 1.5 1.5h12c.8284 0 1.5-.6716 1.5-1.5v-12.17157c0-.66304-.2634-1.29893-.7322-1.76777z", fill: "#f6d2d1", stroke: "#e88483" }),
        react_1.default.createElement("path", { d: "m14.5 3v3.5c0 .55228.4477 1 1 1h3.5", stroke: "#e88483" }),
        react_1.default.createElement("rect", { fill: "#d72321", height: "9", rx: "2", width: "17", y: "11" }),
        react_1.default.createElement("rect", { fill: "#d72321", height: "7", rx: "1", width: "13", x: "2", y: "12" }),
        react_1.default.createElement("g", { stroke: "#fff", strokeLinecap: "round" },
            react_1.default.createElement("path", { d: "m3.5 17.5v-2m0 0v-1.8c0-.1105.08954-.2.2-.2h1c.55228 0 1 .4477 1 1 0 .5523-.44772 1-1 1z" }),
            react_1.default.createElement("path", { d: "m7.5 17.3v-3.6c0-.1105.08954-.2.2-.2h.3c.82843 0 1.5.6716 1.5 1.5v1c0 .8284-.67157 1.5-1.5 1.5h-.3c-.11046 0-.2-.0895-.2-.2z" }),
            react_1.default.createElement("path", { d: "m11.5 17.5v-3.8c0-.1105.0895-.2.2-.2h1.8" }),
            react_1.default.createElement("path", { d: "m11.5 15.5h1" })),
        !isDecorative && react_1.default.createElement("title", null, "pdf file icon")));
}
exports.default = Pdf;
